/* eslint-disable */
import { Message, MessageBox } from 'element-ui'
import ls from '@utils/localStore'
import { createUserRoles, getRoleName, isCentralAccount, ROLE_CONFIG } from '@utils/user-role'
import { login } from '@api/user'
import { getMgAccounts, getTemplateDownloadUrl } from '@api/project'
import { branchAllTemplates } from '@views/workspace/constants'
import router from '../../router'

export default {
    namespaced: true,
    state: {
        token: ls.get('token') || '',
        userProject: ls.get('userProject') || [],
        userPermission: Array.isArray(ls.get('userPermission')) ? ls.get('userPermission') : [],
        userInfo: ls.get('userInfo') || {},
        branchId: ls.get('BRANCHID') || '',
        downloadTemplate: ls.get('BRANCH_TEMPLATES') || {},
        currentModule: ls.get('MODULE') || '',
        lastNotice: ls.get('LAST_NOTICE') || [],
        lastRemind: ls.get('LAST_REMIND') || []
    },
    getters: {
        opUserName: state => {
            return getRoleName(state.userInfo)
        },  
        isCentral(state) {
            return isCentralAccount(state.userPermission)
        }
    },
    mutations: {
        setToken(state, token) {
            state.token = token
            ls.set('token', token)
        },
        setUserProject(state, userProject) {
            state.userProject = userProject
            ls.set('userProject', userProject)
        },
        setUserPermission(state, userPermission) {
            state.userPermission = userPermission
            ls.set('userPermission', userPermission)
        },
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo
            ls.set('userInfo', userInfo)
        },
        setBranchId(state, branchId) {
            state.branchId = branchId
            ls.set('BRANCHID', branchId) 
        },
        setDownloadTemplate(state, downloadTemplate) {
            state.downloadTemplate = downloadTemplate
            ls.set('BRANCH_TEMPLATES', downloadTemplate) 
        },
        setCurrentModule(state, currentModule) {
            state.currentModule = currentModule
            ls.set('MODULE', currentModule) 
        },
        setLastNotice(state, lastData) {
            lastData = [
                ...state.lastNotice,
                lastData
            ]
            state.lastNotice = lastData
            ls.set('LAST_NOTICE', lastData) 
        },
        setLastRemind(state, lastData) {
            lastData = [
                ...state.lastRemind,
                lastData
            ]
            state.lastRemind = lastData
            ls.set('LAST_REMIND', lastData) 
        }
    },
    actions: {
        async login({ commit, dispatch }, payload) {
            try {
                let res = await login(payload)
                if (res && res.access_token) {
                    const { token_type, access_token } = res
                    commit('setToken', `${ token_type } ${ access_token }`)
                    res = await getMgAccounts()
                    if (res && res.result) {
                        const { projectList = [] } = res.result
                        commit('setUserProject', projectList)
                        ls.set('PROJECTUID', (projectList[0] || {}).uid)
                        const _permissions = createUserRoles(res.result)
                        if ( _permissions.length) {
                            commit('setUserPermission', _permissions)
                            await dispatch('setUserInfo', _permissions[0])
                            const _redirect = router.query && router.query.redirect
                            router.replace({ path: (_redirect && !_redirect.startsWith('/login')) ? _redirect : '/' })
                        } else {
                            dispatch('clearCache')
                            Message.warning('您还未加入任何机构，如有疑问请联系上级组织')
                        }
                       
                    } else {
                        dispatch('clearCache')
                        Message.warning('您还未加入任何机构，如有疑问请联系上级组织')
                    }
                }            
            } catch (error) {
                dispatch('clearCache')
            }
        },

        async refreshUserRoles({ commit }) {
            const res = await getMgAccounts()
            if (!res || !res.result) throw new Error('加载角色信息失败，请重试')
            const roles = createUserRoles(res.result)
            commit('setUserPermission', roles)
            return roles
        },

        setUserInfo({ commit }, payload) {
            const name = getRoleName(payload)
            commit('setUserInfo', { ...payload, name, orgName: name })
            const roleConfig = ROLE_CONFIG[payload.type]
            if (roleConfig && !roleConfig.manager) {
                ls.set('BRANCHFLAG', 'add')
                // BRANCHID 沿用旧缓存名称，业务接口实际需要原始 uid。
                commit('setBranchId', payload.uid || '')
            } else {
                ls.set('BRANCHFLAG', 'detail')
                commit('setBranchId', '')
            }
        },

        async logout({ dispatch }) {
            try {
                await MessageBox.confirm('确定退出登录吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                })
            } catch (action) {
                // 取消按钮和关闭弹窗都会拒绝 Promise，属于正常取消退出。
                if (action === 'cancel' || action === 'close') return
                throw action
            }
            await dispatch('clearCache')
            return router.push({ path: '/login' })
        },

        async pwdLogout({ dispatch }) {
            await MessageBox.confirm('修改密码成功，请退出重新登录', '提示', {
                confirmButtonText: '确定',
                showCancelButton: false,
                showClose: false,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                type: 'success', 
            })
            dispatch('clearCache')
            router.push({ path: '/login' })
        },

        clearCache({ commit }) {
            commit('setToken', '')
            commit('setUserInfo', {})
            commit('setUserProject', [])   
            commit('setUserPermission', [])
            commit('setBranchId', '')
            commit('setDownloadTemplate', {})
            commit('setCurrentModule', '')
            ls.remove('token')
            ls.remove('userInfo')
            ls.remove('userProject')
            ls.remove('userPermission')
            ls.remove('BRANCHID')
            ls.remove('BRANCHFLAG')
            ls.remove('BRANCH_TEMPLATES')
            ls.remove('MODULE')
            ls.remove('ORGANIZATION')
            ls.remove('PROJECTUID')
            ls.remove('ARTICLE_INFO')
        },

        setChannel({ commit }, payload) {
            commit('setCurrentModule', payload)
        },

        async getDownloadTemplate({ commit }) {
            try {
                const res = await getTemplateDownloadUrl()  
                if (res && res.result) {
                    const templates = {}
                    Object.keys(res.result).forEach(k => {
                        const _k = branchAllTemplates[k]
                        if (_k) {
                            templates[ _k ] = {
                                name: res.result[k].item,
                                url: res.result[k].value3
                            }
                        }
                    })
                    commit('setDownloadTemplate', templates)     
                }  

            } catch (error) {
                console.log(error)
            }
        },

        setLast({ commit }, payload) {
            const { type, params = {} } = payload
            commit(type == 'notice' ? 'setLastNotice' : 'setLastRemind', params)
        }
    }
}
